import { useState, Fragment } from 'react'
import { makeStyles, withStyles, Grid, Switch, Link as MuiLink } from '@material-ui/core'
import clsx from 'clsx'
import LinesEllipsis from 'react-lines-ellipsis'
import { useTranslation } from 'next-i18next'

const AntSwitch = withStyles((theme) => ({
  root: {
    width: 56,
    height: 32,
    padding: 0,
    display: 'flex',
  },
  switchBase: {
    padding: 4,
    color: theme.palette.grey[500],
    '&$checked': {
      transform: 'translateX(24px)',
      color: theme.palette.common.white,
      '& + $track': {
        opacity: 1,
        backgroundColor: theme.palette.primary.main,
        borderColor: theme.palette.primary.main,
      },
    },
  },
  thumb: {
    width: 24,
    height: 24,
    boxShadow: 'none',
  },
  track: {
    border: `1px solid ${theme.palette.grey[500]}`,
    borderRadius: 32 / 2,
    opacity: 1,
    backgroundColor: theme.palette.common.white,
  },
  checked: {},
}))(Switch)

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    padding: theme.spacing(1),
    textAlign: 'left',
    flex: 1,
    overflow: 'auto',
  },
  title: {
    margin: `${theme.spacing(1)}px 0`,
    fontWeight: 500,
    fontSize: 20,
    ...theme.headerFont,
  },
  title2: {
    margin: `${theme.spacing(1)}px 0`,
    marginTop: theme.spacing(2),
    fontWeight: 500,
    fontSize: 16,
    ...theme.headerFont,
  },
  p: {
    margin: 0,
    padding: `${theme.spacing(1)}px 0`,
    color: '#8C8C8C',
  },
  flexColRight: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
    justifyContent: 'space-evenly',
  },
  colorPrimary: {
    color: theme.palette.primary.main,
  },
  textRight: {
    textAlign: 'right',
  }
}))

const PdpaSetting = ({ isDesktop, switchStates, handleSwitchChange }) => {

  const classes = useStyles()
  const [isExtended,setExtended] = useState([0,0,0,0])
  const { t } = useTranslation('pdpa')

  const settings = [
    {
      title: t('nec-cookies'),
      desc: t('nec-cookies-desc'),
      switch: () => (
        <h5 className={clsx(classes.title2,classes.colorPrimary,classes.textRight)}>{t('always-enabled')}</h5>
      )
    },
    {
      title: t('analytic'),
      desc: t('analytic-desc'),
      switch: () => (
        <AntSwitch name="performance" checked={switchStates.performance} onChange={handleSwitchChange} />
      )
    },
    {
      title: t('functionality'),
      desc: t('functionality-desc'),
      switch: () => (
        <AntSwitch name="functionality" checked={switchStates.functionality} onChange={handleSwitchChange} />
      )
    },
    {
      title: t('targeting'),
      desc: t('targeting-desc'),
      switch: () => (
        <AntSwitch name="targeting" checked={switchStates.targeting} onChange={handleSwitchChange} />
      )
    }
  ]

  const setExtendedByIndex = (index,value) => {
    let newList = [...isExtended]
    newList[index] = value
    setExtended(newList)
  }

  return (
    <div className={classes.root}>
      <Grid container>
        <Grid item xs={12}>
          <h5 className={classes.title}>{t('setting-title')}</h5>
          <p className={classes.p}>{t('setting-desc')}</p>
        </Grid>
        {settings.map((settingObj,index) => (
          <Fragment key={settingObj.title}>
            <Grid item xs={9} md={10}>
              <h5 className={classes.title2}>{settingObj.title}</h5>
            </Grid>
            <Grid item xs={3} md={2} className={classes.flexColRight}>
              {settingObj.switch()}
            </Grid>
            <Grid item xs={12} md={10}>
              {(isExtended[index] || isDesktop) ? (
                <p className={classes.p}>
                  {settingObj.desc}
                </p>
              ):(
                <LinesEllipsis
                  text={settingObj.desc}
                  maxLine={2}
                  ellipsis={<>...<MuiLink onClick={() => setExtendedByIndex(index,true)}>{t('read-more')}</MuiLink></>}
                  trimRight
                  basedOn="letters"
                  component="p"
                  className={classes.p}
                />
              )}
            </Grid>
            {isDesktop && <Grid item xs={2} />}
          </Fragment>
        ))}
      </Grid>
    </div>
  )
}

export default PdpaSetting